import View from "../framework/view";
import grapesjs, {Editor} from 'grapesjs';
import {Media, Product} from "../bo/product";
import template from "../../pugc/image-reorder";

const classname = "image-reorder";

type Listener = (items: Media[]) => void;

export class ImageReorder extends View {

    private initialising = false;

    private product: Product;

    private editor?: Editor;

    private listener? : Listener;

    constructor(product: Product, listener?: Listener) {
        super(classname);
        this.product = product;
        this.listener = listener;
    }

    private async configureEditor() {

        // handle repaint of parent
        if (this.initialising) {
            return;
        }
        this.initialising = true;

        // @ts-ignore
        await import("grapesjs/dist/css/grapes.min.css");

        const elt = this.elt();
        if (elt.data("init") || this.editor) {
            return;
        }
        elt.data("init", true);

        const containerId = `#${this.getUuid()}-gjs`;

        // @ts-ignore
        const editor = this.editor = grapesjs.init({
            container: containerId,
            fromElement: true,
            height: '600px',
            width: 'auto',
            storageManager: false,
            canvasCss: `
img {
    border: solid 1px black;
    max-width: 200px;
    margin: 8px;
}            
            `
        });

        editor.on("update", () => {
            const components = editor.getComponents();
            const urls = components.models.map(m => m.getAttributes()["src"]);

            const itemByUrl : any = {};
            for (const item of this.product?.media?.items || []) {
                itemByUrl[item.image?.url as string] = item;
            }

            const items : Media[] = urls.map(url => itemByUrl[url]) as Media[];
            this.listener && this.listener(items);
        });
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            product: this.product
        }
        const out = this.pug(template, data);

        this.afterUpdate(() => {
            this.configureEditor();
        });

        return out;

    }


}
